module.exports = __webpack_public_path__ + "media/hph-24-07_we-are-georgia.d14ae349.mp4";